export default __webpack_public_path__ + "static/media/notification-sound.749959b1.mp3";